module.exports = __webpack_public_path__ + "static/media/ball.aba20cb2.svg";